import { NewsFeedAuthorDTO, NewsFeedDTO } from 'http-requests/news';

const mapAuthor = (author: NewsFeedAuthorDTO | null) => {
  if (!author) {
    return null;
  }

  return {
    id: author.id,
    provider: author.provider ?? '',
    str_name: author.str_name ?? '',
    provider_name: author.provider_name,
    is_super: author.is_super ?? false,
    display_organization: author.display_organization ?? false,
  };
};

function mapBase(dto: NewsFeedDTO) {
  return {
    id: dto.id,
    subject: dto.subject,
    body: dto.body,
    state: dto.state,
    author: mapAuthor(dto.author),
    publishAt: dto.publish_at,
    expiresAt: dto.expires_at,
    createdAt: dto.created_at,
    updatedAt: dto.updated_at,
    forWorkers: dto.for_workers,
    forTenants: dto.for_tenants,
    forProviders: dto.for_providers,
    forContractors: dto.for_contractors,
    departmentOnly: dto.department_only,
    files: dto.files,
    statistics: dto.statistics ?? null,
  };
}

export function mapNewsFeedItem(dto: NewsFeedDTO) {
  switch (dto.type) {
    case 'news':
      return {
        ...mapBase(dto),
        type: 'news' as const,
        category: dto.category ?? null,
        photos: dto.photos,
      };
    case 'event':
      return {
        ...mapBase(dto),
        type: 'event' as const,
        eventType: dto.event_type,
        resource: dto.resource,
        periodStart: dto.period_start,
        periodEnd: dto.period_end,
        isActual: dto.is_actual,
        addresses: dto.addresses.map((a) => ({
          house: a.house,
          address: a.address,
          apartments: a.apartments.map((id) => ({ id, name: id })),
        })),
      };
    case 'telephonogram':
      return {
        ...mapBase(dto),
        type: 'telephonogram' as const,
        telephonogramType: dto.telephonogram_type,
      };
  }
}
